import { DCarouselResponsiveSettings } from "@dfa/ui-platform";

export const featuredResponsiveCards: DCarouselResponsiveSettings = [
	{
		breakpoint: 1440,
		settings: {
			cardsPerSection: 3,
			cardsToScroll: 2
		}
	},
	{
		breakpoint: 1024,
		settings: {
			cardsPerSection: 2,
			cardsToScroll: 1
		}
	},
	{
		breakpoint: 768,
		settings: {
			cardsPerSection: 1,
			cardsToScroll: 1,
			autoplaySettings: {
				autoplayDirection: "forwards",
				intervalDuration: 4000
			},
			wraps: true
		}
	}
];

export const standardResponsiveCards: DCarouselResponsiveSettings = [
	{
		breakpoint: 1440,
		settings: {
			cardsPerSection: 3,
			cardsToScroll: 3
		}
	},
	{
		breakpoint: 1024,
		settings: {
			cardsPerSection: 2,
			cardsToScroll: 2
		}
	},
	{
		breakpoint: 768,
		settings: {
			cardsPerSection: 1,
			cardsToScroll: 1,
			autoplaySettings: {
				autoplayDirection: "forwards",
				intervalDuration: 4000
			},
			wraps: true
		}
	}
];

export const oneToOneResponsiveCards: DCarouselResponsiveSettings = [
	{
		breakpoint: 1440,
		settings: {
			cardsPerSection: 1,
			cardsToScroll: 1
		}
	},
	{
		breakpoint: 1024,
		settings: {
			cardsPerSection: 1,
			cardsToScroll: 1
		}
	},
	{
		breakpoint: 768,
		settings: {
			cardsPerSection: 1,
			cardsToScroll: 1,
			autoplaySettings: {
				autoplayDirection: "forwards",
				intervalDuration: 4000
			},
			wraps: true
		}
	}
];
